export class StoreSearchTextAction {
    static readonly type = '[Search] Store Search Text Action';

    constructor(public payload: { text: string }) { }
}

export class ClearSearchTextAction {
    static readonly type = '[Search] Clear Search Text Action';
}
